<template>
  <div class="topbar-container">
    <!--Left section - DATE AND ICONS-->
    <div class="left hidden-sm-and-down">
      <DateAndLinkCard></DateAndLinkCard>
      2
    </div>
    <!--Middle section - LOGO-->
    <!--Normal-->
    <div class="center" v-if="$vuetify.breakpoint.smAndUp">
      <router-link to="/front">
        <img src="/wenewz_middle_2color.svg" alt="wenewz logo" />
      </router-link>
    </div>
    <!--Phone-->
    <div class="pt-5" v-else>
      <router-link to="/front">
        <img src="/wenewz_middle_2color.svg" alt="wenewz logo" width="70px"/>
      </router-link>
    </div>
    <!--Right section - BELL, PROFILE, FLAG AND SEARCH-->
    <!--Display If NOT on user page (Phoneisation within this component)-->
    <div v-if="!isUserPage" class="ma-0 pa-0">
      <NavbarRightBig></NavbarRightBig>
    </div>
    <!--Phone-->
    <div v-else class="pt-4">
      <v-row>
        <!-- <v-col class="ma-0 pa-0"><LanguageSelector></LanguageSelector></v-col> -->
        <v-col class="ma-0 pa-0" v-if="$vuetify.breakpoint.mdAndDown"> <SidebarRight></SidebarRight></v-col>
        <!-- <v-col><v-btn to="/" v-if="$vuetify.breakpoint.smAndUp">Frontpage</v-btn></v-col> -->
      </v-row>
    </div>
  </div>
</template>

<script>
// Function imported from vuex
import { mapGetters } from "vuex";
// i18n imported
import messages from "../modules/lang/export";
// Component imports
import DateAndLinkCard from "@/components/navbar/components/dateAndLinkCard.vue";
import NavbarRightBig from "@/components/navbar/components/LayoutRightSide.vue";
import LanguageSelector from "@/components/navbar/components/language_selector.vue";
import SidebarRight from "@/components/navbar/sidebarRight.vue";
export default {
  name: "App",
  // I18n used
  i18n: { messages },
  components: {
    DateAndLinkCard,
    NavbarRightBig,
    LanguageSelector,
    SidebarRight
  },
  data() {
    return {
      scrolled: false
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn", "authStatus"]),
    isUserPage() {
      return this.$route.name ==='listarticles' 
      || this.$route.name == 'dashboard' 
      || this.$route.name ==='editprofile' 
      || this.$route.name ==='createarticle' 
      || this.$route.name ==='profilesettings' 
      || this.$route.name ==='editfrontpagesettings'
      || this.$route.name ==='inbox'
      || this.$route.name ==='follows'
      || this.$route.name ==='managefeeds'
      || this.$route.name ==='editarticle'
    }
  },
  methods: {
    handleScroll () {
      this.scrolled = window.scrollY > 0;
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>

.topbar-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: flex-start;
}
.topbar-container > * {
  /* width: 100%; */
  margin-bottom: 20px;
}

.topbar-container .left {
  order: 0;
  flex: 0  auto;
  align-self: auto;
  /* text-align: left; */
}

.topbar-container .center {
  order: 0;
  flex: 0 2 auto;
  align-self: auto;
}
/*Image for the center Big Navbar*/
.topbar-container .center img {
  width: 150px;
}
/*Image for the left Small Navbar*/
.topbar-container .left img {
  width: 55px;
}

.topbar-container .right {
  /* margin: 15px; */
  order: 0;
  /* flex: 0 1 auto; */
  /* align-self: auto; */
  text-align: right;
}
.topbar-container .right a,
a.articlelinks {
  text-decoration: none;
  color: black;
}
.topbar-container .right a:hover,
a.articlelinks:hover {
  text-decoration: underline;
}
.topbar-menu-container {
  border-bottom: 4px solid black;
  padding-bottom: 20px;
}
.topbar-menu-container .flex {
  text-align: center;
  /* font-size: 1.2em; */
}
</style>
